import ff from './ff';

export default class i11d { // 時間帯パターン情報

static d_defs = {

/*
  DROP TABLE t_i11r;
  CREATE TABLE "t_i11r" ("_key" SERIAL PRIMARY KEY, "_vsn" INTEGER, "_ltt" INTEGER, "_fst" INTEGER, 
    "i11rb21f" INTEGER,
    "i11rc11s" TEXT,
    "i11rc31s" TEXT,
    "i11rcx1i" INTEGER,
    "i11rcy1t" TEXT,
    "i11rcy1f" INTEGER,
    "i11rcz1i" INTEGER
  );
  INSERT INTO t_i11r (_vsn, _ltt, i11rb21f, i11rc11s, i11rc31s, i11rcx1i, i11rcy1t, i11rcy1f, i11rcz1i)
  VALUES (1, 1, 1, '1', 'パターン1', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i11r (_vsn, _ltt, i11rb21f, i11rc11s, i11rc31s, i11rcx1i, i11rcy1t, i11rcy1f, i11rcz1i)
  VALUES (1, 1, 1, '2', 'パターン2', 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_i11r SET _fst = _key;

*/

  i11r: {
    0: {
      pfx: '時間帯情報',
      b_vsn: true,
/*
      d_insDats: {
        b_upd: false,
        b_new: true,
        b_dlt: false,
        d_flds: {
          i11rb21f: -1,
          i11rc11s: '',
          i11rc31s: '',
        },
      },
*/
      d_insFlds: {
        i11rc11s: '',
        i11rc31s: '',
      },
      dd_fldDefss: {
        i11rb21f: { 
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        i11rc11s: {
          pfx: '時間帯区分ID',
          type: 'Inp',
          n_col: 5,
        },
        i11rc31s: {
          pfx: '時間帯区分名',
          type: 'Inp',
          n_col: 15,
        },
      },
    },
  },

/*
  DROP TABLE t_i110;
  CREATE TABLE "t_i110" ("_key" SERIAL PRIMARY KEY, "_vsn" INTEGER, "_ltt" INTEGER, "_fst" INTEGER, 
    "i110b21f" INTEGER,
    "i110b51k" INTEGER,
    "i110c11s" TEXT,
    "i110c31s" TEXT,
    "i110i11t" TEXT,
    "i110i12t" TEXT,
    "i110cx1i" INTEGER,
    "i110cy1t" TEXT,
    "i110cy1f" INTEGER,
    "i110cz1i" INTEGER
  );
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 1, '1', '午前', '9', '12', 1, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 1, '2', '午後1', '12', '15', 2, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 1, '3', '午後2', '15', '18', 3, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 1, '4', '夜間', '18', '21', 4, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 2, '1', '午前1', '9', '11', 1, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 2, '2', '午前2', '11', '13', 2, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 2, '3', '午後1', '13', '15', 3, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 2, '4', '午後2', '15', '17', 4, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 2, '5', '夜間1', '17', '19', 5, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i110 (_vsn, _ltt, i110b21f, i110b51k, i110c11s, i110c31s, i110i11t, i110i12t, i110cx1i, i110cy1t, i110cy1f, i110cz1i)
  VALUES (1, 1, 1, 2, '6', '夜間2', '19', '21', 6, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_i110 SET _fst = _key;

*/

  i110: {
    0: {
      pfx: '時間帯情報子',
      b_vsn: true,
      d_insFlds: {
        i110c11s: '',
        i110c31s: '',
        i110i11t: '',
        i110i12t: '',
      },
      dd_fldDefss: {
        i110b21f: { // c20r_fst
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        i110b51k: { // i11r_fst or i11r_key ?
          pfx: 'i11r_key',
          type: 'Inp',
        },
        i110c11s: {
          pfx: '時間帯ID',
          type: 'Inp',
          n_col: 5,
        },
        i110c31s: {
          pfx: '時間帯名',
          type: 'Inp',
          n_col: 6,
        },
        i110i11t: {
          pfx: '開始時刻',
          type: 'Inp',
          n_col: 3,
          bsd: '時',
        },
        i110i12t: {
          pfx: '終了時刻',
          type: 'Inp',
          n_col: 3,
          bsd: '時',
        },
      },
    },
  },

};

};
